import React, { useEffect } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { setGlobal, getGlobal } from 'reactn';
import ReactGA from 'react-ga';
import PrivateRoute from './Auth/PrivateRoute';
import UserLayout from './components/user/layout/Layout';
import AuthLayout from './components/auth/Layout';
import defaultGlobalState from './defaultGlobalState';

ReactGA.initialize(process.env.REACT_APP_GA_KEY);

const jwt = JSON.parse(localStorage.getItem('jwt'));

setGlobal({ ...defaultGlobalState, jwt });

const App = () => {
  const { userId } = getGlobal();

  let location = useLocation();
  useEffect(() => {
    ReactGA.pageview(location.pathname + location.search);
  }, [location]);

  return (
    <>
      <Switch>
        <Route
          path="/"
          exact
          component={() => {
            if (userId) {
              return <Redirect to="/user/dashboard" />;
            }
            return <Redirect to="/auth/signin" />;
          }}
        />
        <Route path="/auth" component={AuthLayout} />
        <PrivateRoute path="/user" component={UserLayout} />
      </Switch>
    </>
  );
};

export default App;
